import { css } from '@emotion/react'
import { useState, useEffect } from 'react'
import BarLoader from 'react-spinners/BarLoader'
import { baseColor } from '../../../../lib/styles/colors'
import { useStudentNetworkStatus } from '../../../../lib/clients/getStudentClientOIDC'
import DelayedRender from '../DelayedRender'

// add display: flex as workaround for disappearing BarLoader problem
// https://github.com/davidhu2000/react-spinners/issues/341
// https://www.w3.org/TR/css3-grid-layout/#grid-placement-int
const barContainerCss = css`
  grid-column: 1 / -1;
  grid-row: 2;
  height: 100%;
  width: 100%;
  display: flex;
`

type LoadBarProps = {
  /** Bypasses isLoading and displays <BarLoader /> */
  persist?: boolean
}

// TODO: integrate with scheduler GraphQL client
const LoadBar = ({ persist }: LoadBarProps) => {
  const { numPendingQueries: pendingStudentQueries } = useStudentNetworkStatus()
  const [isMounted, setIsMounted] = useState(true)
  const isLoading = pendingStudentQueries > 0

  useEffect(
    () => () => {
      setIsMounted(false)
    },
    []
  )

  if (!isMounted) return null

  return (
    <div css={barContainerCss}>
      {(isLoading || persist) && (
        <DelayedRender delay={50}>
          <BarLoader color={baseColor} width="100%" />
        </DelayedRender>
      )}
    </div>
  )
}

export default LoadBar
